/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "e12e32bd1adb81f514b37a0698470315d070cab5";
